import { createSelector } from 'reselect';

import { StoreState } from '../index';
import { DAFULT_VENDOR_PEGBOARD } from '../../utils/constants';
import { SelectedVendorPegboard } from './vendorPegboard.types';

export const vendorPegboardSelector = (state: StoreState) => state.vendorPegboard;

export const pegboardsSelector = createSelector(
  vendorPegboardSelector,
  (vendorPegboard) => vendorPegboard.pegboards,
);

export const defaultVendorPegboardSelector = createSelector(
  pegboardsSelector,
  (vendorPegboards) => {
    const defaultVendorPegboard = Object.keys(vendorPegboards).filter(p => {
      const [vendor] = p.split(',');

      return vendor.toLocaleLowerCase() === DAFULT_VENDOR_PEGBOARD;
    });

    if (defaultVendorPegboard.length) {
      const [vendor, startHoleX, startHoleY] = defaultVendorPegboard[0].split(',');

      return { vendor, startHoleX, startHoleY } as SelectedVendorPegboard;
    }

    return null;
  }
);

export const vendorPegboardGroupInfoByConfigIdSelector = (configId: string | null) => createSelector(
  pegboardsSelector,
  defaultVendorPegboardSelector,
  (pegboards, defaultPegboard) => {
    if (configId === null) return defaultPegboard;

    const pegboardGroup = Object.keys(pegboards).reduce((acc, cur) => {
      const pegbordFound = pegboards[cur].filter(p => p.pegboardConfigId === configId);

      if (pegbordFound.length && acc === '') acc = cur;

      return acc;
    }, '');
    const [vendor, startHoleX, startHoleY] = pegboardGroup.split(',');

    return { vendor, startHoleX, startHoleY } as SelectedVendorPegboard;
  }
);
